/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_TitleInputs */

const en_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three steps to your next offer`)
};

const de_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei Schritte zu deinem naechsten Angebot`)
};

const fr_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trois étapes vers ta prochaine offre`)
};

const es_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres pasos hasta tu próxima oferta`)
};

const it_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre passi verso la tua prossima offerta`)
};

const nl_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drie stappen naar je volgende aanbod`)
};

const pl_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trzy kroki do następnej oferty`)
};

const fi_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolme askelta seuraavaan tarjoukseen`)
};

const da_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre trin til dit næste jobtilbud`)
};

const sv_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre steg till ditt nästa erbjudande`)
};

/**
* | output |
* | --- |
* | "Three steps to your next offer" |
*
* @param {Landing_How_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_how_title = /** @type {((inputs?: Landing_How_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_how_title(inputs)
	if (locale === "fr") return fr_landing_how_title(inputs)
	if (locale === "es") return es_landing_how_title(inputs)
	if (locale === "it") return it_landing_how_title(inputs)
	if (locale === "nl") return nl_landing_how_title(inputs)
	if (locale === "pl") return pl_landing_how_title(inputs)
	if (locale === "fi") return fi_landing_how_title(inputs)
	if (locale === "da") return da_landing_how_title(inputs)
	if (locale === "sv") return sv_landing_how_title(inputs)
	return en_landing_how_title(inputs)
});